//noScroll
class InterviewModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const openBtn = document.querySelectorAll(".c-parts-swiper__slide");
    const closeBtn = document.querySelector(".interviewModal__close");
    const overlay = document.querySelector(".modal-overlay");

    const modal = document.querySelector(".interviewModal");
    const modalImgPath = document.querySelector(".interviewModal__img");
    const modalTime = document.querySelector(".interviewModal__time");
    const modalTitle = document.querySelector(".interviewModal__ttl");
    const modalText = document.querySelector(".interviewModal__body-txt");
    const body = document.querySelector("body");


    openBtn.forEach(trigger => {
      trigger.addEventListener("click", () => {
        $('.interviewModal__inner').scrollTop(0);
        const ImgPath = trigger.querySelector(".interviewModal__imgPath").getAttribute('src');
        modalImgPath.setAttribute('src', ImgPath);

        modalTime.innerHTML = trigger.querySelector(".c-parts-swiper__slide-time").innerHTML
        modalTitle.innerHTML = trigger.querySelector(".c-parts-swiper__slide-ttl").innerHTML
        modalText.innerHTML = trigger.querySelector(".c-parts-swiper__slide-body").innerHTML

        modal.classList.add('is-active')
        overlay.classList.add('is-active')

        scrollBan();
      })
    })

    if(closeBtn){
      closeBtn.addEventListener("click", () => {
        modal.classList.remove("is-active")
        overlay.classList.remove("is-active")
        scrollBan();
      })
    }

    overlay.addEventListener("click", () => {
      modal.classList.remove("is-active")
      overlay.classList.remove("is-active")
      scrollBan();
    })

  }
}
